<template>
  <v-card
    style="border-radius: 0;background-color: #111130;color:white;z-index: 100;"
    class="mx-auto fixed-header"
  >
    <div @click="go_to_home" style="text-align: center">{{ $t('zoodkomak') }}</div>
    <v-app-bar
      dark
      class=""
      style="height: 77px;background-color: #111130;color:white"
    >
      <v-row style="width: 100%" v-if="!is_mobile">
        <v-col cols="4" style="display: inline-flex;align-items: center;">
          <div @click="toggle_drawer">
            <v-icon>mdi-menu</v-icon>
          </div>
          <div @click="go_to_profile" v-if="get_user_image() !=''" style="margin-left: 10px;margin-right: 10px;" class="circle-img">
            <img :src="get_user_image()"/>
          </div>
          <span  class="router-name">
          {{get_user_name()}}
        </span>
        </v-col>
        <v-col cols="4">
          <v-text-field
            :placeholder="$t('Search')"
            outlined
            v-model="search_text"
            dense
            @keypress.enter="go_to_search"
            style="height: 30px;min-height: 30px"
            append-icon="mdi-magnify"
            background-color="white"
            light
            @click:append="go_to_search()"
          />
        </v-col>
        <v-col  cols="4" style="display: inline-flex;justify-content: end;align-items: center;">
          <div @click="go_to_call()">
            <v-icon class="circle-img">mdi-phone</v-icon>
          </div>

          <span @click="go_to_call()" class="router-name" style="margin-right: 10px">
           {{$t('call1662')}}
        </span>
          <div style="margin-right: 10px" v-on:click="$router.go(-1)" v-if="$route.path !='/home-tab'&& $route.path !='/' ">
            <v-icon>mdi-arrow-left</v-icon>
          </div>
        </v-col>
      </v-row>
      <v-row style="width: 100%" v-if="is_mobile">
        <v-col cols="6" style="display: inline-flex;align-items: center;">
          <div @click="toggle_drawer">
            <v-icon>mdi-menu</v-icon>
          </div>
          <div @click="go_to_profile" v-if="get_user_image() !=''" style="margin-left: 10px;margin-right: 10px;" class="circle-img">
            <img :src="get_user_image()"/>
          </div>
          <span  class="router-name">
          {{get_user_name()}}
        </span>
        </v-col>
        <v-col  cols="6" style="display: inline-flex;justify-content: end;align-items: center;">
          <div  @click="go_to_call">
            <v-icon class="circle-img">mdi-phone</v-icon>
          </div>

          <span  @click="go_to_call" class="router-name" style="margin-right: 10px">
           {{$t('call1662')}}
        </span>
          <div style="margin-right: 10px" v-on:click="$router.go(-1)" v-if="$route.path !='/home-tab' && $route.path !='/' ">
            <v-icon>mdi-arrow-left</v-icon>
          </div>

        </v-col>
        <v-col cols="12" style="margin-top: 5px">
          <v-text-field
            :placeholder="$t('Search')"
            outlined
            v-model="search_text"
            dense
            @keypress.enter="go_to_search"
            style="height: 30px;min-height: 30px"
            append-icon="mdi-magnify"
            background-color="white"
            light
            @click:append="go_to_search()"
          />
        </v-col>

      </v-row>

      <v-toolbar-title>

      </v-toolbar-title>

      <v-spacer></v-spacer>
    </v-app-bar>
  </v-card>
</template>
<script>
  import {bus} from '../main'
  import Vue from 'vue'
  export default {
    name: 'CustomHeader',
    components: {
    },
    mounted() {
      console.log("header mounted");
      window.addEventListener('resize', this.resize_mobile(), {passive: true})
      this.resize_mobile()
      },
    computed:{

    },
    props:{
      is_mobile:Boolean
    },
    data () {
      return {
        search_text:'',
      }
    },

    methods:{
      go_to_call(){
        window.open('tel:1662',"_self")
      },
      go_to_home(){
        this.$router.push({path:'/'})
      },
      resize_mobile() {
        console.log('set mobile size');

        if (window.innerWidth < 600) {
          this.is_mobile=true
        } else {
          this.is_mobile=false
        }
      },
      go_to_search () {
        if (this.search_text != '') {
          this.$router.push({ path:'/search/' + this.search_text })
        }
      },
      toggle_drawer(){
        console.log("toggle drawer bus called")
        bus.$emit('toggle_drawer',true);
      },
      go_to_profile () {
        var profile = localStorage.getItem('profile')
        if (profile == null) {
          this.$router.push({ path:'/login' })
        }
        var phone = localStorage.getItem('phone')
        var password = localStorage.getItem('password')
        var data = {
          name:JSON.parse(profile).UserName,
          phone:phone,
          password:password
        }
        var json_data = JSON.stringify(data)
        var cesar_data = this.caesar(json_data)
        // var encode_data = unescape(encodeURIComponent(cesar_data))
        var encode_data = (encodeURIComponent(cesar_data))
        // var base64_data = btoa(encode_data)
        var final_url = 'https://cp.zoodkomak.com/login-api/' + encode_data

        // console.log('cesar data = ',cesar_data)
        // console.log('encode data = ',encode_data)
        // console.log('base64 data = ',base64_data)
        //
        // var un_base64_data = atob(base64_data);
        // var un_decode_data = decodeURIComponent(un_base64_data);
        // var decesar = this.decaesar(un_decode_data);
        // console.log('base64 decode = ',un_base64_data)
        // console.log('decode decode = ',un_decode_data)
        // console.log('decesar decode = ',decesar)
        // console.log('final url = ',final_url)
        window.open(final_url)
        // this.$router.push({path:'/message-tab'})
      },
      caesar (str) {
        str = str.split('')
        str = str.map(char => {
          let code = char.charCodeAt(0)

          // if( (code > 64 && code < 78) || (code > 96 && code < 110) )
          code += 85

          // else if ( (code > 77 && code < 91) || (code > 109 && code < 123) )
          //   code -= 13

          return String.fromCharCode(code)
        })

        return str.join('')
      },
      decaesar (str) {
        str = str.split('')
        str = str.map(char => {
          let code = char.charCodeAt(0)

          // if( (code > 64 && code < 78) || (code > 96 && code < 110) )
          code -= 85

          // else if ( (code > 77 && code < 91) || (code > 109 && code < 123) )
          //   code -= 13

          return String.fromCharCode(code)
        })

        return str.join('')
      },
    }
  }
</script>
